// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1FK_v{background:#fff;border-radius:4px}._1_xUI{padding:.75rem 1rem;color:#231815;border-bottom:1px solid #dcdddd}@media(max-width:1023px){._1_xUI{border-top:1px solid #dcdddd}}.XZsGz{overflow-y:scroll}._2gwMo{max-height:168px;max-height:10.5rem}.pAumx{max-height:356px;max-height:22.25rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_1FK_v",
	"title": "_1_xUI",
	"content": "XZsGz",
	"small": "_2gwMo",
	"large": "pAumx"
};
module.exports = exports;
